export enum FileInputRenderingStatus  {
    initial = "initial",
    loading = "loading",
    success = "success",
    failure = "failure"
}

export enum FileStatus  {
    sending = "sending",
    failure = "failure"
}


// WEBPACK FOOTER //
// ./src/components/FormFileInput/FileStatus.ts